import { render, staticRenderFns } from "./addresident.vue?vue&type=template&id=3f96df32&"
import script from "./addresident.vue?vue&type=script&lang=js&"
export * from "./addresident.vue?vue&type=script&lang=js&"
import style0 from "./addresident.vue?vue&type=style&index=0&id=3f96df32&prod&lang=css&"
import style1 from "./addresident.vue?vue&type=style&index=1&id=3f96df32&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports